export const live = {
  title: "ライブ",
  listTitle: "配信",
  trending: "急上昇",
  live: "LIVE",
  standby: "待機中",
  /** 無料視聴中のヘッダー表示 */
  freeWatching: "無料視聴中",
  viewerCount: (args: { count: string | number }) => `${args.count}人視聴中`,
  pastBroadcastNotice: "※再生されている映像は過去の配信映像です。",
  pointPerMinute: (args: { point: string | number }) => `${args.point}pt/分`,
  noChannels: "ライブ配信中のチャンネルはありません",
  leave: "終了",
  remainingPoint: (args: { point: string | number }) => `残り ${args.point}pt`,
  chatPlaceholder: "メッセージ",
  toyMenu: "Toyメニュー",
  toyPointCost: (args: { point: string | number }) => `${args.point}pt`,
  durationSeconds: (args: { duration: string | number }) =>
    `${args.duration}秒`,
  purchase: "購入",
  remoteVibe: "遠隔バイブ",
  remoteVibeMenuTitle: "遠隔バイブメニュー",
  openRemoteVibeMenu: "遠隔バイブメニューを開く",
  onedari: "おねだり",
  onedariTitle: "おねだりメニュー",
  lovenseSentMessage: (args: { name: string | number }) =>
    `「${args.name}」のLovenseを送信しました💗`,
  presentSentMessage: (args: { text: string | number }) =>
    `「${args.text}」のチップを送信しました！🎁`,
  chargeTitle: "ポイントをチャージ",
  chargeDoneTitle: "チャージ完了！",
  chargeDoneDesc: (args: { point: string | number }) =>
    `${args.point}ptを獲得しました`,
  insufficientPointTitle: "ポイントが不足しています",
  insufficientPointDescription:
    "ライブを視聴するにはポイントが必要です。ポイントを購入してください。",
  pointWarning: (args: { minutes: string | number }) =>
    `残り${args.minutes}分でポイントが不足します`,
  lovenseActive: "実行中",
  lovenseControlling: "コントロール中",
  lovenseRemaining: (args: { seconds: string | number }) =>
    `残り${args.seconds}秒`,
  lovenseIntensity: (args: { intensity: string | number }) =>
    `強度 ${args.intensity}/20`,
  lovenseFullControlMenu: "完全コントロールメニュー",
  lovenseHide: "非表示",
  lovenseTypes: {
    full_control: "フルコントロール",
  },
  insufficientPointToast: "ポイント不足により視聴が終了しました",
  pointWillRunOutToast: "残り1分で視聴が終了します",
  openProfile: "配信者のプロフィールを表示",
  mute: "ミュート",
  unmute: "ミュート解除",
  leaveConfirm: {
    title: "視聴を終了しますか？",
    confirm: "終了する",
  },
  entryCountdown: {
    badge: "まもなく入室します",
    description: "自動で配信に入室します",
    cancel: "キャンセル",
  },
  directWatch: {
    invalidLink: "リンクが正しくありません",
    loginFailed: "ログインできませんでした",
    notLive: "現在配信していません",
    error: "読み込みに失敗しました",
    ended: "視聴を終了しました",
    liveEnded: "配信が終了しました",
    guestNotice: "ログインせずに視聴しています（コメント・ギフトは使えません）",
    closeHint: "この画面を閉じてください",
  },
  /** 管理画面で「ここから有料」にされた配信の表示 */
  paidLive: {
    badge: "有料配信",
    title: "ここからは有料配信です",
    descriptionLead: "この配信の続きは、",
    descriptionEmphasis: "過去30日以内にポイントを購入した方",
    descriptionTail:
      "だけが見られます。コースを購入すると、すぐに続きが見られます。",
    courseTitle: "コースを選ぶ",
    courseNote: "購入から30日間、有料配信が見られます",
    coursePoint: (args: { point: string | number }) => `${args.point} pt`,
    coursePrice: (args: { price: string | number }) => `¥${args.price}`,
    purchase: "購入して続きを見る",
    backToList: "配信一覧に戻る",
    switchedTitle: "有料配信に切り替わりました",
    switchedDescription: "過去30日以内にご購入があるので、このまま見られます",
  },
} as const;
